module.exports = __webpack_public_path__ + "static/media/check-whiteSmoke.eafede35.svg";